import { ArrowRight, Phone } from "lucide-react";
import { Link } from "wouter";
import { SITE_DETAILS } from "@shared/site";

type CtaBandProps = {
  eyebrow?: string;
  title: string;
  body?: string;
  primaryLabel?: string;
  primaryHref?: string;
};

export function CtaBand({
  eyebrow = "Start a conversation",
  title,
  body,
  primaryLabel = "Request a call",
  primaryHref = "/inquiry",
}: CtaBandProps) {
  return (
    <section className="closing-cta" aria-label={title}>
      <div className="container closing-cta-inner">
        <div>
          <p className="section-kicker light">{eyebrow}</p>
          <h2>{title}</h2>
          {body ? <p className="closing-copy">{body}</p> : null}
        </div>
        <div className="closing-actions">
          <Link className="button-light" href={primaryHref}>{primaryLabel} <ArrowRight size={18} /></Link>
          <a href={SITE_DETAILS.phoneHref}><Phone size={17} /> {SITE_DETAILS.phoneDisplay}</a>
        </div>
      </div>
    </section>
  );
}
